import Swiper from 'swiper/bundle';

const swiperSlide = new Swiper(".swiper.m-slide", {
  spaceBetween: 50,
  centeredSlides: true,
  grabCursor: true,
  slidesPerView: 1,
  loop: true,
  breakpoints: {
    // 768px以上の場合
    768: {
      centeredSlides: false,
      slidesPerView: 3,
      slidesPerGroup: 3,
      loopFillGroupWithBlank: true,
    }
  },
  // ページネーションが必要なら追加
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  // ナビボタンが必要なら追加
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev"
  }
});


const swiperFade = new Swiper(".swiper.m-fade", {
  spaceBetween: 50,
  effect: "fade",
  // centeredSlides: true,
  // grabCursor: true,
  slidesPerView: 1,
  loop: true,
  pauseOnMouseEnter: true,
  // autoplay: {
  //   delay: 2500,
  //   disableOnInteraction: false,
  // },
  // ページネーションが必要なら追加
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  // ナビボタンが必要なら追加
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev"
  }
});

swiperFade.on('slideChangeTransitionStart', function () {
  var activeSlide = swiperFade.slides[swiperFade.activeIndex];
  var bgColor = window.getComputedStyle(activeSlide).backgroundColor;
  swiperFade.el.querySelector('.swiper-wrapper').style.backgroundColor = bgColor;
});

const swiperFade2 = new Swiper(".swiper.m-fade2", {
  spaceBetween: 50,
  effect: "fade",
  // centeredSlides: true,
  // grabCursor: true,
  slidesPerView: 1,
  loop: true,
  pauseOnMouseEnter: true,
  // autoplay: {
  //   delay: 2500,
  //   disableOnInteraction: false,
  // },
  // ページネーションが必要なら追加
  // pagination: {
  //   el: ".swiper-pagination",
  //   clickable: true,
  // },
  // ナビボタンが必要なら追加
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev"
  }
});

const swiperFade3 = new Swiper(".swiper.m-fade3", {
  spaceBetween: 50,
  effect: "fade",
  // centeredSlides: true,
  // grabCursor: true,
  slidesPerView: 1,
  loop: true,
  pauseOnMouseEnter: true,
  // autoplay: {
  //   delay: 2500,
  //   disableOnInteraction: false,
  // },
  // ページネーションが必要なら追加
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  // ナビボタンが必要なら追加
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev"
  }
});

const swiper = new Swiper(".swiper.mySwiper", {
  spaceBetween: 10,
  // centeredSlides: true,
  // grabCursor: true,
  slidesPerView: 3,
  slidesPerGroup: 1,
  pauseOnMouseEnter: true,
  breakpoints: {
    // 768px以上の場合
    768: {
      spaceBetween: 20
    }
  },
  freeMode: true,
  watchSlidesProgress: true,
});

const swiper2 = new Swiper(".swiper.mySwiper2", {
  spaceBetween: 50,
  effect: "fade",
  // centeredSlides: true,
  // grabCursor: true,
  slidesPerView: 1,
  loop: true,
  pauseOnMouseEnter: true,
  // autoplay: {
  //   delay: 2500,
  //   disableOnInteraction: false,
  // },
  // ページネーションが必要なら追加
  // pagination: {
  //   el: ".swiper-pagination",
  //   clickable: true,
  // },
  // ナビボタンが必要なら追加
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev"
  },
  thumbs: {
    swiper: swiper,
  }
});

const swiper3 = new Swiper(".swiper.mySwiper3", {
  spaceBetween: 5,
  // centeredSlides: true,
  // grabCursor: true,
  slidesPerView: 7,
  slidesPerGroup: 1,
  pauseOnMouseEnter: true,
  breakpoints: {
    // 768px以上の場合
    768: {
      spaceBetween: 10
    }
  },
  grid: {
    fill: 'row',
    rows: 2,
  },
  freeMode: true,
  watchSlidesProgress: true,
});

const swiper4 = new Swiper(".swiper.mySwiper4", {
  spaceBetween: 50,
  effect: "fade",
  // centeredSlides: true,
  // grabCursor: true,
  slidesPerView: 1,
  loop: true,
  pauseOnMouseEnter: true,
  // autoplay: {
  //   delay: 2500,
  //   disableOnInteraction: false,
  // },
  // ページネーションが必要なら追加
  // pagination: {
  //   el: ".swiper-pagination",
  //   clickable: true,
  // },
  // ナビボタンが必要なら追加
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev"
  },
  thumbs: {
    swiper: swiper3,
  }
});

const swiper5 = new Swiper(".swiper.mySwiper5", {
  // spaceBetween: 5,
  // centeredSlides: true,
  // grabCursor: true,
  slidesPerView: 3,
  slidesPerGroup: 1,
  pauseOnMouseEnter: true,
  // breakpoints: {
  //   // 768px以上の場合
  //   768: {
  //     spaceBetween: 10
  //   }
  // },
  grid: {
    fill: 'row',
    rows: 2,
  },
  freeMode: true,
  watchSlidesProgress: true,
});

const swiper6 = new Swiper(".swiper.mySwiper6", {
  spaceBetween: 50,
  effect: "fade",
  // centeredSlides: true,
  // grabCursor: true,
  slidesPerView: 1,
  loop: true,
  pauseOnMouseEnter: true,
  // autoplay: {
  //   delay: 2500,
  //   disableOnInteraction: false,
  // },
  // ページネーションが必要なら追加
  // pagination: {
  //   el: ".swiper-pagination",
  //   clickable: true,
  // },
  // ナビボタンが必要なら追加
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev"
  },
  thumbs: {
    swiper: swiper5,
  }
});

